module.exports = __webpack_public_path__ + "images/discover_newsletter-mobile.jpg";